// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingPageVanity_root__3ouEw","loadingText":"ListingPageVanity_loadingText__3HoAn"};